import React, { useEffect, useState } from "react";

import Text from "../../shared/text/Text";
import OTPInput from "../../shared/Inputs/OTPInput";
import HeroImage from "./HeroImage";
import styles from "./ClaimOwnershipModal.module.scss";

const RESEND_TIMER_SECONDS = 30;

const useResendTimer = (initial = RESEND_TIMER_SECONDS) => {
  const [seconds, setSeconds] = useState(initial);

  useEffect(() => {
    if (seconds <= 0) return;
    const id = setTimeout(() => setSeconds((s) => s - 1), 1000);
    return () => clearTimeout(id);
  }, [seconds]);

  return [seconds, () => setSeconds(initial)];
};

const formatTimer = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

const OtpInputBody = ({
  body,
  state,
  setState,
  dispatchAction,
  errors = {},
}) => {
  const { primary, secondary, imageUrl } = body ?? {};
  const { title: primaryTitle, subtitle: primarySubtitle } = primary ?? {};
  const { title: secondaryTitle, buttonConfig: secondaryButtons } =
    secondary ?? {};

  const [seconds, resetTimer] = useResendTimer();
  const isResendDisabled = seconds > 0;
  const otpError = errors.otp;

  const handleChange = (value) => {
    setState((s) => ({
      ...s,
      otp: value === "" ? undefined : value,
    }));
  };

  const handleResendClick = (action) => {
    if (isResendDisabled || !action) return;
    dispatchAction?.(action);
    resetTimer();
  };

  return (
    <div className={styles.otpBody}>
      <HeroImage imageUrl={imageUrl} align="left" />
      <Text uiData={primaryTitle} className={styles.otpTitle} />
      <Text uiData={primarySubtitle} className={styles.otpSubtitle} />

      <div className={styles.otpInputRow}>
        <OTPInput
          value={state?.otp ?? ""}
          onChange={handleChange}
          error={otpError ? <Text uiData={otpError} /> : ""}
          numericOnly
        />
      </div>

      <div className={styles.otpSecondaryRow}>
        <span className={styles.otpTimer}>{formatTimer(seconds)}</span>
        <section className={styles.otpSecondaryWrapper}>
          <Text uiData={secondaryTitle} className={styles.otpSecondary} />
          {secondaryButtons?.map((btn, idx) => {
            const { mainContent, action } = btn ?? {};
            return (
              <button
                key={idx}
                type="button"
                className={`${styles.otpResendBtn} ${
                  isResendDisabled ? styles.otpResendBtnDisabled : ""
                }`}
                disabled={isResendDisabled}
                onClick={() => handleResendClick(action)}
              >
                <Text uiData={mainContent?.title} />
              </button>
            );
          })}
        </section>
      </div>
    </div>
  );
};

export default OtpInputBody;
